import type { SqliteIdbStoredCache } from '@src/modules/platform/local-sqlite/infrastructure/sqliteIdbCodec.ts';

export type LocalSqlitePersistState = {
  idbCache: SqliteIdbStoredCache;
  dirty: boolean;
};

let dirtySink: LocalSqlitePersistState | undefined;
let dirtyNotifier: (() => void) | undefined;

export function bindLocalSqlitePersistState(state: LocalSqlitePersistState): void {
  dirtySink = state;
}

/** Debounced IDB persist (e.g. `notifyPersist`) after in-memory writes; default 600ms. */
export function bindLocalSqliteDirtyNotifier(notify: () => void): void {
  dirtyNotifier = notify;
}

export function isLocalSqliteDirty(): boolean {
  return dirtySink?.dirty === true;
}

export function resetLocalSqlitePersistState(): void {
  dirtySink = undefined;
  dirtyNotifier = undefined;
}

export function markLocalSqliteDirty(): void {
  if (dirtySink) dirtySink.dirty = true;
  dirtyNotifier?.();
}
